module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/1_e9e2a17429549621b9c9d4518260e410.png";